import { api } from "./client";
import type {
  AuthResponse,
  Envelope,
  MeResponse,
  Session,
} from "./types";

/** Endpoints de autenticação do CLIENTE (docs/api.md). */

export interface RegisterInput {
  /**
   * Opcional: quem está começando a prospectar nem sempre tem empresa. Sem
   * ele, o backend dá um nome previsível à conta (ver `Auth::RegisterAccount`).
   */
  account_name?: string;
  document?: string;
  name: string;
  email: string;
  password: string;
}

export interface LoginInput {
  email: string;
  password: string;
  /** Só quando o usuário pertence a mais de uma conta. */
  account_id?: string;
}

export const authApi = {
  register: (input: RegisterInput) =>
    api.post<AuthResponse>("/api/v1/auth/register", {
      body: { registration: input },
    }),

  login: (input: LoginInput) =>
    api.post<AuthResponse>("/api/v1/auth/login", { body: { session: input } }),

  logout: () => api.post<void>("/api/v1/auth/logout"),

  me: (signal?: AbortSignal) =>
    api.get<MeResponse>("/api/v1/auth/me", signal ? { signal } : {}),

  forgotPassword: (email: string) =>
    api.post<{ message: string }>("/api/v1/auth/password/forgot", {
      body: { password: { email } },
    }),

  resetPassword: (token: string, password: string) =>
    api.post<void>("/api/v1/auth/password/reset", {
      body: { password: { token, password } },
    }),

  listSessions: () => api.get<{ data: Session[] }>("/api/v1/sessions"),

  revokeSession: (id: string) => api.delete<void>(`/api/v1/sessions/${id}`),
};

export type { Envelope };
